export interface Testimonio {
  nombre: string
  rol: string
  lugar: string
  texto: string
}

export const testimonios: Testimonio[] = [
  {
    nombre: 'Carolina M.',
    rol: 'Profesora de Ciudadanía',
    lugar: 'La Plata, Buenos Aires',
    texto:
      'Tenía que armar una jornada ESI en tres días. Abrí el kit, elegí la propuesta y la adapté al grupo. Me ahorró un fin de semana entero.',
  },
  {
    nombre: 'Julián P.',
    rol: 'Preceptor de 3° y 4° año',
    lugar: 'Córdoba Capital',
    texto:
      'Los casos para debatir son lo mejor: los chicos se enganchan porque son situaciones que les pasan de verdad.',
  },
  {
    nombre: 'Valeria S.',
    rol: 'Orientadora escolar',
    lugar: 'San Miguel de Tucumán',
    texto:
      'La guía para temas sensibles me dio herramientas concretas para encuadrar charlas de salud mental sin quedarme trabada.',
  },
  {
    nombre: 'Martín G.',
    rol: 'Profesor de Lengua y tutor',
    lugar: 'Bahía Blanca, Buenos Aires',
    texto:
      'Uso las actividades de 10 minutos para abrir la clase. Cambió por completo el clima del curso.',
  },
  {
    nombre: 'Sofía R.',
    rol: 'Equipo de convivencia',
    lugar: 'Mendoza',
    texto:
      'Lo compartimos entre todo el equipo. Trabajamos bullying y redes con material serio y actual, sin improvisar.',
  },
  {
    nombre: 'Federico T.',
    rol: 'Profesor de Biología',
    lugar: 'Santa Fe Capital',
    texto:
      'Las actividades de ciudadanía digital me sirvieron para hablar de IA y fake news con quinto año. Muy bien planteadas.',
  },
]
